export const TEMPLATE_NOT_AVAILABLE_IN_ENVIRONMENT_PAGE = {
  NOT_YET_SEND_TO_PUBLISH_TEXT: {
    key: 'NOT_YET_SEND_TO_PUBLISH_TEXT',
    value: 'Template not yet published',
  },
  NOT_YET_SEND_FOR_TESTING_TEXT: {
    key: 'NOT_YET_SEND_FOR_TESTING_TEXT',
    value: 'Template not yet send for testing.',
  },
};
